import React, { useContext } from 'react';
import { Modal } from '@lifeomic/chroma-react/components/Modal';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { AttachmentViewerContext } from './AttachmentViewerProvider';

interface Props {
  isOpen: boolean;
  children?: React.ReactNode;
  title?: string;
}

const useStyles = makeStyles(() => ({
  attachmentViewerModalBody: {
    position: 'relative',
    padding: 0,
  },
  activeAttachmentContainerL1: {
    width: '100%',
    height: '100%',
    backgroundColor: '#c0c0c0',
    display: 'table',
  },
  activeAttachmentContainerL2: {
    display: 'table-cell',
    verticalAlign: 'middle',
  },
  activeAttachmentContainerL3: {
    textAlign: 'center',
  },
}));

export const AttachmentViewerModal: React.FC<Props> = (props: Props) => {
  const { isOpen, children } = props;
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  const { setActiveAttachmentImage: setActiveAttachment } = useContext(
    AttachmentViewerContext,
  );
  const classes = useStyles(props);
  return (
    <Modal
      isOpen={isOpen}
      isFullScreen={true}
      onDismiss={() => setActiveAttachment(null)}
      contentClassName={classes.attachmentViewerModalBody}
    >
      <div className={classes.activeAttachmentContainerL1}>
        <div className={classes.activeAttachmentContainerL2}>
          <div className={classes.activeAttachmentContainerL3}>{children}</div>
        </div>
      </div>
    </Modal>
  );
};
